export const HipaaValidationError = class HipaaValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ValidationError";
  }
};
